import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useBetween } from 'use-between';
import Logo from '../photo/logo.jpg'
import SSS from '../photo/SSS.jpg'
import './App.css'
import WOW from 'wowjs';
import File from "./file1.pdf";
import File2 from './file2.pdf'

const App = () => {

const { lang, arrayLang, aboutRef } = useBetween(
  useSelector((state) => state.useSharedLang)
);
  useEffect(() => {
    new WOW.WOW({
      live: false
    }).init();
  }, [])


  return (
    <div className="AboutUs" ref={aboutRef}>
      {/* ---------------------AboutUs-------------------------------- */}
      <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/npm/animate.css@3.5.2/animate.min.css"
      />
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.2.1/css/all.min.css"
      />

      <div className="AboutUs1">
        <img
          src={Logo}
          className="img img2 wow bounceInLeft"
          data-wow-delay="0.7s"
          data-wow-duration="2s"
        />
        <div
          className="Info"
          style={{ direction: lang == "AR" ? "rtl" : "ltr" }}
        >
          <h5 className="wow fadeIn" data-wow-delay="0.8s">
            {arrayLang.AboutUs}
          </h5>
          <h4 className="wow fadeIn" data-wow-delay="0.9s">
            {arrayLang.Laundry}
          </h4>
          <p
            className=" text1 wow bounceInRight"
            data-wow-delay="1s"
            data-wow-duration="2s"
          >
            {arrayLang.text1}
            <br />
            {arrayLang.text2} <br />
            {arrayLang.text3}
          </p>
          <h5 className="wow fadeIn" data-wow-delay="0.8s">
            {arrayLang.DefineTheSystem}
          </h5>

          <p
            className="wow bounceInRight"
            data-wow-delay="1s"
            data-wow-duration="2s"
          >
            {arrayLang.p1}
          </p>
          <a
            className="download2"
            style={{ display: lang === "AR" ? "inline" : "none" }}
            href={File}
            download="نظام خدمات التنظيف السعودية"
            target="_blank"
          >
            {arrayLang.download}
            <i className="fa fa-download" aria-hidden="true"></i>
          </a>
          <a
            className="download2"
            style={{ display: lang === "AR" ? "none" : "inline" }}
            href={File2}
            download="Saudi cleaning services system.pdf"
            target="_blank"
          >
            {arrayLang.download}
            <i className="fa fa-download" aria-hidden="true"></i>
          </a>
        </div>
      </div>
      
       
    </div>
    // -------------------------/AboutUs---------------------------------------
  );
}


export default App;